
import { mapGetters } from "vuex";


export default {
  props: {
    ticketGroup: Object,
    onClickBack: Function,
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      quantity: "checkout/quantity",
      selectedTicketGroup: "checkout/selectedTicketGroup",
      activePromoCode: "checkout/activePromoCode",
    }),
    quantitySelect: {
      get() {
        return this.quantity;
      },
      set(quantitySelect) {
        this.$store.commit("checkout/quantity", Number(quantitySelect));

      },

    },
    switchGroupDiscountLinkPromoText() {
      if (this.activePromoCode?.code === 'groupdiscount') {
        return `BACK TO PROMO CODE`
      }
      return `USE GROUP DISCOUNT`
    },

    backgroundImage() {
      return this.activePromoCode?.mobile?.backgroundImage ? this.activePromoCode?.mobile?.backgroundImage : ''
    },
    promotionalTexts() {
      let texts = {
        title: {
          green: '',
          complement: '',
        },
        benefits: {
          bold: '',
          normal: ''
        }
      }

      switch (this.activePromoCode?.code) {
        case 'peppertixpromo': {
          texts = {
            title: {
              green: `Save ${this.activePromoCode?.discountValue}%`,
              complement: ` on your first buy`,
            },
            benefits: {
              bold: `Sign up, get ${this.activePromoCode?.discountValue}% discount, and access to`,
              normal: ' group discounts and promo codes.'
            }
          }
          break;
        }
        case 'groupdiscount': {
          texts = {
            title: {
              green: `Save ${this.activePromoCode?.discountValue}%`,
              complement: ` on your first ticket`,
            },
            benefits: {
              normal: `If you buy 2 tickets or more,`,
              bold: ` save the first ticket resale fees`
            }
          }
          break;
        }
        default: {

          texts = {
            title: {
              green: `Save ${this.activePromoCode?.discountValue}%`,
              complement: ` on your purchase`,
            },
            benefits: {
              bold: `Buy all your tickets with a ${this.activePromoCode?.discountValue}% discount.`,
              normal: ` ${this.activePromoCode?.message.split(". ")[1]}`
            }
          }
          break;

        }
      }

      return texts
    },

    multiplier() {
      if (!this.activePromoCode) {
        return 0
      }
      let multiplier1 = this.quantity
      if (this.activePromoCode.onlyAppliesToFirstTicket === true) {
        multiplier1 = 1
      }

      return multiplier1
    },
    discount() {
      if (!this.activePromoCode) {
        return 0
      }

      let discountValue = 0
      if (this.quantity <= 1 && this.activePromoCode.onlyAppliesToFirstTicket === true) {
        return 0
      }

      if (this.activePromoCode) {
        discountValue = this.activePromoCode.discountValue
      }


      const disount1 =
        ((this.selectedTicketGroup?.wholesale_price *
          discountValue) /
          100) *
        this.multiplier;

      return Math.round(disount1 * 100 + Number.EPSILON) / 100;
    },

    subTotal() {
      const subTotal = this.wholesale_price * this.quantity
      return Math.round(subTotal * 100 + Number.EPSILON) / 100;
    },
    subTotalWithDiscount() {
      const subTotal1 = this.wholesale_price * this.quantity - this.discount
      return Math.round(subTotal1 * 100 + Number.EPSILON) / 100
    }

  },

  data() {
    return {
      scrolling: false,
      promoCopy: {},
      nextPromoSwitch: {},
      wholesale_price: 0,
      prevScrollTop: 0,
      splits: [],

    }
  },

  watch: {
    backgroundImage(val) {
      console.log(val)
    }
  },
  async mounted() {
    this.$nextTick(async () => {
      const ticketGroup = this.ticketGroup
      if (!ticketGroup) {
        return
      }
      this.wholesale_price = ticketGroup ? ticketGroup?.wholesale_price : 0

      this.splits = ticketGroup.splits
      const quantity = ticketGroup ? ticketGroup?.splits[0] : 1
      this.$store.commit("checkout/quantity", quantity);



      console.log('this.activePromoCode.code -->' + this.activePromoCode?.code)
      if (this.activePromoCode) {
        if (this.activePromoCode?.code != 'groupdiscount' && this.activePromoCode?.code != 'peppertixpromo') {
          this.promoCopy = this.activePromoCode
        }

      }



    })

  },
  watch: {
    activePromoCode(val) {
      if (val) {
        console.log(val.mobile.backgroundImage)
      }
    }
  },
  methods: {
    handleScroll2(event) {
      const scrollableDiv = event.target;
      if (scrollableDiv.scrollTop > 0 &&
        scrollableDiv.scrollTop + scrollableDiv.clientHeight < scrollableDiv.scrollHeight) {
        this.scrolling = true
      } else {
        this.scrolling = false
      }
    },

    handleScroll(event) {
      const scrollableDiv = event.target;
      if (scrollableDiv.scrollTop > this.prevScrollTop) {
        // Scroll hacia abajo
        this.scrolling = true;
      } else if (scrollableDiv.scrollTop === 0) {
        // Scroll hacia arriba y llega al tope
        this.scrolling = false;
      }
      this.prevScrollTop = scrollableDiv.scrollTop;
    },

    async onClickSwitchGroupDiscountLinkPromo() {
      let body = {};
      if (!this.user?.isClient) {
        return;
      }

      if (this.activePromoCode?.code != 'groupdiscount') {
        body.code = 'groupdiscount';
      } else {
        body.code = this.promoCopy?.code
      }


      await this.$store.dispatch("checkout/verifyPromoCode", body);

    },
    handleSplitUpdate(value) {
      this.quantitySelect = value;
      console.log(this.quantitySelect)
    },
    checkout() {
      // Implement the checkout logic here
    },

    onInputQuantity: function (event) {
      this.$store.commit("checkout/quantity", event.target.value);

      // this.$store.dispatch("checkout/recalculateTotal")

    },

    close() {
      this.$emit("close");
      console.log('close-')
    }

  },
};
